var _a, _b;
import __cjsInterop1__ from "@emotion/is-prop-valid";
const { default: isPropValid = __cjsInterop1__ } = ((_b = (_a = __cjsInterop1__) == null ? void 0 : _a.default) == null ? void 0 : _b.__esModule) ? __cjsInterop1__.default : __cjsInterop1__;
const filterValidProps = (props) => Object.entries(props).filter(([key]) => isPropValid(key)).reduce((res, [key, value]) => ({ ...res, [key]: value }), {});
export {
  filterValidProps as default
};
//# sourceMappingURL=filterValidProps.es.js.map
